export enum LOGIN_INPUTS_MAX_LENGHT {
    "username" = 50,
    "password" = 65
}